var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('button',{staticClass:"scroll-btn",on:{"click":_vm.scrollToTop}},[_c('img',{staticClass:"arrow-up",attrs:{"src":require("../../assets/Svg/arrow-down.svg"),"alt":"top"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }